import { Conference, ConferenceService } from '@gbhem/api';
import { Column } from 'react-table';

import { Table } from '../../components';

const columns = [
  {
    Header: 'NAME',
    accessor: 'name',
    id: 'name',
    Cell: ({ value }) => value
  },
  {
    Header: 'EPISCOPAL AREA',
    accessor: 'episcopalArea',
    id: 'episcopalArea',
    Cell: ({ value }) => value.name
  }
] as Column<Conference>[];

export function Conferences() {
  const initialPageSize = 10;
  const initialPageIndex = 0;

  return (
    <Table
      columns={columns}
      data={[]}
      pageIndex={initialPageIndex}
      pageSize={initialPageSize}
      count={0}
      loader={async (props) => {
        const quickSearch = await ConferenceService.quickSearch(
          'Conference',
          props.size,
          props.page * props.size,
          ['episcopalArea'],
          props.isQuickSearch,
          props.orderBy,
          props.filters
        );

        return { data: quickSearch.data, count: quickSearch.count };
      }}
    />
  );
}

export default Conferences;
